import React, { Component } from 'react';
import {Form, FormControl, ListGroup, Button} from 'react-bootstrap';
import axios from 'axios';
import DemoModal from "./LearnMore";

class SearchForm extends Component {
    constructor(props) {
        super(props);
        this.state = {search_name: '',
            search_results: []};

        this.handleChange = this.handleChange.bind(this);
    }


    handleChange(event) {
        let search_term = event.target.value;
        // this.setState({search_name: event.target.value});
        // replace with api companieshouse and HTTPSSSS!
        // https://api.companieshouse.gov.uk
        const url = `https://api.companieshouse.gov.uk/search/companies?items_per_page=5&q=`+search_term

        const username = 'r6K45B5TRky0kjSO_YleNvq3WmK2XZiiv8wCZQAY'

        const token = Buffer.from(`${username}:`, 'utf8').toString('base64')

        axios.get(url, {
            crossDomain: true,
            headers: {
                'Authorization': `Basic ${token}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then(res => {
                let search_results = res['data']['items'].map(item =>  ({ name: item.title}))
                this.setState({search_name: search_term, search_results: search_results});
            }).catch(res => {

                this.setState({search_name: search_term});
        })

    }

    render() {
        return <ListGroup>
            <ListGroup.Item>
                <Form>
                    <FormControl type="text" placeholder="Search by company name" value={this.state.search_name} onChange={this.handleChange}/>
                </Form>
            </ListGroup.Item>
            {this.state.search_results.map((item, index) => (
                <ListGroup.Item key={index} className="p-2"><DemoModal variant="light" text_inside={item.name}/></ListGroup.Item>
            ))}
        </ListGroup>

    }
}
export default SearchForm;
